/**
  * @function normalizeAlarmType
  * @memberof Util.Alarm
  * @description Normalize alarm type for consistent styling
  *
  * @param {string} type string alarm type
  * @returns {string} normalized alarm type
  */
export function normalizeAlarmType (type) {
  if (!type) return 'Unknown';
  if (type.toLowerCase().includes('rtd')) return 'RtdFault';
  return type;
}
